import square_big from '../../img/shapes/square_big.png';
import square_small from '../../img/shapes/square_small.png';
import triangle_big from '../../img/shapes/triangle_big.png';
import triangle_small from '../../img/shapes/triangle_small.png';
import circle_big from '../../img/shapes/circle_big.png';
import circle_small from '../../img/shapes/circle_small.png';

import airplane_blue from '../../img/airplanes/airplane_blue.png';
import airplane_red from '../../img/airplanes/airplane_red.png';
import airplane_green from '../../img/airplanes/airplane_green.png';
import airplane_yellow from '../../img/airplanes/airplane_yellow.png';
import airplane_purple from '../../img/airplanes/airplane_purple.png';
import airplane_white from '../../img/airplanes/airplane_white.png';

import person from '../../img/icons/person.png';
import persons from '../../img/icons/persons.png';
import dice from '../../img/icons/dice.png';
import speed from '../../img/icons/speed.png';
import ticket from '../../img/icons/ticket.png';
import timer from '../../img/icons/timer.png';
import hand from '../../img/icons/hand.png';
import video from '../../img/icons/video.png';
import link from '../../img/icons/link.png';
import audio_on from '../../img/icons/audio_on.png';
import audio_off from '../../img/icons/audio_off.png';
import next from '../../img/icons/next.png';

import lock_big from '../../img/shapes/lock_big.png';
import lock_small from '../../img/icons/lock.png';
import arrow_right from '../../img/icons/arrow_right.png';

import map from '../../img/map.png';
import airport from '../../img/images/airport.png';
import airplane from '../../img/images/airplane.png';
import advance from '../../img/images/advance.png';
import manager from '../../img/images/manager.png';
import lounge from '../../img/images/lounge.png';

export const IMAGES = {
  map,
  lock_big,
  lock_small,
  airport,
  airplane,
  advance,
  manager,
  lounge,
  AIRPLANES: {
    blue: airplane_blue,
    red: airplane_red,
    green: airplane_green,
    yellow: airplane_yellow,
    purple: airplane_purple,
    white: airplane_white,
  },
  SHAPES: {
    square_big,
    square_small,
    triangle_big,
    triangle_small,
    circle_big,
    circle_small,
  },
  ICONS: { person, speed, ticket, timer, arrow_right, hand, video, link, persons, audio_on, audio_off, next, dice },
};
